import { useSelector } from 'react-redux';

import { selectProviderState } from '../modules/provider.module';

export const useIsStudentCheck = () => {
  const { teacher } = useSelector(selectProviderState);

  return !!teacher;
};
